<template>
  <Dialog v-model:visible="cookieDialogIsVisible" :closable="false" :breakpoints="{'960px': '75vw', '640px': '90vw'}"
          :style="{width: '100%'}" position="bottom" :modal="true">
    <div class="grid" style="padding:1em">
      <div class="col-12 lg:col-6">
        {{ $t("footer.text3") }}<br>
        {{ $t("footer.text4") }}
        <a href="https://www.esmo.org/terms-of-use/privacy-policy" target="_blank">{{ $t("footer.privacy-policy") }}</a>.
      </div>
      <div class="col-12 lg:col-6" style="text-align: right;">
        <Button @click="rejectAllCookies()" class="cookie-buttons reject-all">{{ $t("cookies.reject-all") }}</Button>
        <Button @click="acceptAllCookies()" class="cookie-buttons accept-all">{{ $t("cookies.accept-all") }}</Button>
        <div @click="toggleCustomiseCookies()" style="text-decoration: underline; cursor: pointer;margin-top: 1em">
          {{ $t("cookies.customise") }}
        </div>
      </div>
      <div v-if="customiseCookiesIsVisible" class="col-12 grid" style="margin-top: 1em;margin-bottom: 1em;">
        <div class="col-12 md:col-4">
          <InputSwitch v-model="selectedBaseCookies"/>
          <p><b>{{ $t("cookies.baseCookiesTitle") }}</b></p>
          <p>{{ $t("cookies.baseCookiesBody") }}</p>
        </div>
        <div class="col-12 md:col-4">
          <InputSwitch v-model="selectedAnalyticsCookies"/>
          <p><b>{{ $t("cookies.analyticsCookiesTitle") }}</b></p>
          <p>{{ $t("cookies.analyticsCookiesBody") }}</p>
        </div>
        <div class="col-12 md:col-4">
          <InputSwitch v-model="selectedMarketingCookies"/>
          <p><b>{{ $t("cookies.marketingCookiesTitle") }}</b></p>
          <p>{{ $t("cookies.marketingCookiesBody") }}</p>
        </div>
        <div class="col-12">
          <Button @click="saveCookieSettings()" class="cookie-buttons save" style="float: right">
            {{ $t("cookies.save") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
  <div :class="styleClass">
    <span>The ESMO-GROW Online Tool & Informative Score application shall assist researchers only in the self-evaluation of their manuscripts according to ESMO-GROW recommendations.
      The tool does not provide any guarantee of compliance, quality or acceptance for publication.
      ESMO reserves the right to modify these recommendations.
      We will use the details you submit to provide you with customised PDF output and access to a saved version. It will not be used for any other purposes, including communications, marketing, or sharing with third parties. Saved content will be retained only for 2 years and then deleted.
      For further information on how we process your data please view the
      <a class="green-esmo underline" href="https://www.esmo.org/terms-of-use/privacy-policy">ESMO Privacy & Data Security Policy</a>
    </span>
    <div class="green-esmo" style="text-decoration: underline;cursor:pointer;text-align: right" @click="showCookieDialog">Manage Cookies</div>
  </div>
</template>

<script>
import {useApplicationStore} from "@/store/applicationStore";

export default {
  beforeCreate() {
    this.applicationStore = useApplicationStore()
  },
  props: {
    styleClass: {
      type: String,
    },
  },
  data() {
    return {
      selectedBaseCookies: true,
      selectedAnalyticsCookies: false,
      selectedMarketingCookies: false,
      cookieDialogIsVisible: false,
      customiseCookiesIsVisible: false
    }
  },
  methods: {
    toggleCustomiseCookies() {
      this.customiseCookiesIsVisible = !this.customiseCookiesIsVisible
    },
    saveCookieSettings() {
      this.applicationStore.setBaseCookies(this.selectedBaseCookies)
      this.applicationStore.setAnalyticsCookies(this.selectedAnalyticsCookies)
      this.applicationStore.setMarketingCookies(this.selectedMarketingCookies)
      this.customiseCookiesIsVisible = false;
      this.hideCookieDialog()
    },
    acceptAllCookies() {
      this.selectedBaseCookies = true
      this.selectedAnalyticsCookies = true
      this.selectedMarketingCookies = true
      this.saveCookieSettings()
    },
    rejectAllCookies() {
      this.selectedBaseCookies = false
      this.selectedAnalyticsCookies = false
      this.selectedMarketingCookies = false
      this.saveCookieSettings()
    },
    showCookieDialog() {
      this.cookieDialogIsVisible = true;
    },
    hideCookieDialog() {
      this.cookieDialogIsVisible = false;
    },
    activateAnalytics() {
      if (this.analyticsCookies === true) {
        this.$gtm.enable(true)
      } else {
        this.$gtm.enable(false)
      }
    }
  },
  computed: {
    baseCookies() {
      return this.applicationStore.baseCookies
    },
    analyticsCookies() {
      return this.applicationStore.analyticsCookies
    },
    marketingCookies() {
      return this.applicationStore.marketingCookies
    }
  },
  mounted() {
    this.selectedAnalyticsCookies = this.analyticsCookies
    this.selectedMarketingCookies = this.marketingCookies
    if (!this.baseCookies === true) {
      this.showCookieDialog()
    }
    if (this.analyticsCookies === true) {
      this.activateAnalytics()
    }
  },
  watch: {
    analyticsCookies() {
      this.activateAnalytics()
    }
  }
}
</script>

<style scoped lang="scss">
@import "public/theme/theme-esmo";

.cookie-buttons {
  min-width: 10em;
  font-family: "HelveticaLTW05-BlackCond", Arial, Helvetica, sans-serif;
  padding: .8em;
  border: 2px solid $primaryColor;
  margin: .2em;

  &.save {
    color: $primaryColor;
    background: transparent;
  }
}

.app-footer {
  max-width: 105em;
  position: fixed;
  bottom: 0;
  left: 33em;
  padding-left: 2em !important;
  padding-right: 2em !important;
  padding-bottom: .5em;
  z-index: 3;
  color: #A6AEAD;
  font-size: .65em;
  font-weight: 400;
  background-color: #EDF6F4;
  text-align: justify;
}

.app-footer-home {
  left: 0;
  padding-left: 3em !important;
}

.layout-main-footer {
  padding-left: 24rem;
  left: 30em;
}

@media screen and (max-width: 897px) {
  .layout-main-footer {
    padding-left: 2rem;
    text-align: justify-all;
  }
  .app-footer {
    left: 0;
  }
  .app-footer-home {
    margin-left: 0;
    padding-left: 1em !important;
  }
}
</style>